/* eslint-disable @next/next/no-img-element */
'use client'

import { createThumbnailHoverHandlers } from '@/components/video/HoverAnimatedThumbnail'
import { ScenarioNodeWithVideoUrl } from '@/orval/generated/public/model'
import { FC } from 'react'

export interface VideoPlaylistProps {
  nodes: ScenarioNodeWithVideoUrl[]
  currentVideoIndex: number
  onVideoSelect: (index: number) => void
}

const VideoPlaylist: FC<VideoPlaylistProps> = ({ nodes, currentVideoIndex, onVideoSelect }) => {
  return (
    <>
      <style>{`
        .playlist-container {
          display: flex;
          flex-direction: column;
          gap: 6px;
          padding: 12px 6px;
          overflow-y: auto;
          background: #111;
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
        }

        .playlist-container::-webkit-scrollbar {
          width: 3px;
        }

        .playlist-container::-webkit-scrollbar-track {
          background: transparent;
        }

        .playlist-container::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 2px;
        }

        .playlist-item {
          position: relative;
          width: 100px;
          height: 100px;
          flex-shrink: 0;
          margin: 0 auto;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          transition: all 200ms ease;
          border: 2px solid transparent;
        }

        .playlist-item:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
        }

        .playlist-item.active {
          width: 82px;
          height: 82px;
          opacity: 0.6;
          transform: scale(0.9);
          border-color: var(--video-frame-color, var(--video-accent-color, #1d48af));
        }

        .playlist-item.active:hover {
          transform: scale(0.95);
        }

        .playlist-thumbnail {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .playlist-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #333;
          color: #666;
          font-size: 24px;
        }

        // .playlist-overlay {
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   right: 0;
        //   background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
        //   padding: 16px 6px 6px;
        //   pointer-events: none;
        // }

        // .playlist-title {
        //   color: white;
        //   font-size: 10px;
        //   font-weight: 500;
        //   line-height: 1.3;
        //   overflow: hidden;
        //   display: -webkit-box;
        //   -webkit-line-clamp: 2;
        //   -webkit-box-orient: vertical;
        //   text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
        // }
      `}</style>

      <div className="playlist-container">
        {nodes.map((node, index) => {
          const title = node.video?.title || node.title || ''
          return (
            <div
              key={node.id}
              className={`playlist-item ${index === currentVideoIndex ? 'active' : ''}`}
              onClick={() => onVideoSelect(index)}
            >
              {node.thumbnailUrl ? (
                <img
                  src={node.thumbnailUrl}
                  alt={title || `Video ${index + 1}`}
                  className="playlist-thumbnail"
                  {...createThumbnailHoverHandlers(node.thumbnailUrl, node.animatedThumbnailUrl)}
                />
              ) : (
                <div className="playlist-placeholder">
                  <span>▶</span>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}

export default VideoPlaylist
